var _defs, _g, _line, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTomraSustainabilityHubLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 566.9 285.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke: #000;\n      }\n\n      .st0, .st1 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .st2 {\n        fill: #204c89;\n      }\n\n      .st3 {\n        fill: #21426c;\n      }\n\n      .st4 {\n        fill: #0093ca;\n      }\n\n      .st5 {\n        fill: #00233c;\n      }\n\n      .st6 {\n        fill: #2e9bc3;\n      }\n\n      .st1 {\n        stroke: #4ba19c;\n        stroke-width: 3.5px;\n      }\n\n      .st7 {\n        fill: #1e447f;\n      }\n\n      .st8 {\n        fill: #6ebed7;\n      }\n\n      .st9 {\n        fill: #4ba19c;\n      }\n\n      .st10 {\n        fill: #00203a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.5,247.5c-3.6,2.2-7.4,3.8-11.4,4.8h0l-2.2,14.7h-14.5l-1.4-14.7c-4-1-7.8-2.6-11.4-4.8l-11.8,8.8-9.7-9.9,8.7-11.9c-2.2-3.6-3.8-7.6-4.7-11.6l-14.4-2.2v-13.8l14.4-2.2c.9-4,2.6-8,4.7-11.6l-8.7-11.9,9.7-9.9,11.8,8.8c3.6-2.2,7.4-3.8,11.4-4.8l1.4-14.7h15.4l1.4,14.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.1,229.8c30.1-5.7,60.2,15.7,60.2,15.7,0,0-17,5.9-26.7,2.6-5.5-1.9-9.2-8-8.8-13.7.7-13,21.3-21.3,31.8.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.2,163.5c-8.1,4-18.7,12.5-19,25.8,0,2.1-.2,8.8,4.3,14.7,19.2,23.9,50.2-11.8,24.4-44h0c-3.3,28.6-14.5,45.7-20.9,53.8-10.7,13.7-18.7,14.4-22,15.7-8.7,3.3-18.3-1-21.6-9.9-2.9-7.8.3-18.5,9.7-22,8.5-3.1,18.3,1.2,21.6,9.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M143.6,218.4c2.2,2.4,5.6,4.5,10.1,4.5s7-2.6,7-4.9c0-3.4-3.6-4.3-7.7-5.4-5.1-1.3-11.1-2.8-11.1-9.4s4.7-9.1,11.3-9.1,8.8,1.6,11.7,4.5l-2.8,3.6c-2.4-2.6-5.8-3.7-9.3-3.7s-6,1.8-6,4.5,3.5,3.8,7.4,4.8c5.2,1.4,11.3,3,11.3,9.8s-3.5,9.6-12.1,9.6-9.9-2.1-12.6-5.1l2.7-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M187.7,226.6v-3.2c-1.8,1.9-4.7,3.7-8.3,3.7s-7.4-2.5-7.4-7.4v-16.4h4.3v14.9c0,3.8,1.9,5,4.9,5s5.1-1.5,6.4-3.3v-16.7h4.3v23.2h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M199.9,220.4c1.6,1.7,4.7,3.3,7.8,3.3s5-1.3,5-3.3-2.6-3.1-5.6-3.7c-3.9-.9-8.5-2-8.5-7s3.2-6.9,8.8-6.9,6.9,1.4,8.8,3.3l-1.9,3c-1.3-1.6-3.9-2.8-6.9-2.8s-4.8,1.2-4.8,3,2.5,2.7,5.4,3.4c4,.9,8.8,2,8.8,7.3s-3.3,7.1-9.4,7.1-7.3-1.2-9.6-3.6l2.1-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M224.1,221.4v-14.3h-3.8v-3.8h3.8v-6.3h4.3v6.3h4.7v3.8h-4.7v13.3c0,1.6.8,2.8,2.3,2.8s1.9-.4,2.4-.9l1.1,3.3c-.9.9-2.3,1.5-4.5,1.5-3.6,0-5.5-2.1-5.5-5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M253.2,226.6v-2.5c-1.8,2-4.5,3.1-7.6,3.1s-8.1-2.6-8.1-7.7,4.2-7.6,8.1-7.6,5.8,1,7.6,3.1v-3.8c0-2.9-2.4-4.6-5.7-4.6s-4.9,1-7,3.1l-1.9-3c2.6-2.5,5.8-3.8,9.5-3.8s9.3,2.2,9.3,8.1v15.6h-4.3ZM253.2,217.5c-1.3-1.7-3.6-2.6-6-2.6s-5.3,1.9-5.3,4.6,2.2,4.6,5.3,4.6,4.7-.9,6-2.6v-3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M264.7,196.8c0-1.5,1.3-2.8,2.8-2.8s2.8,1.2,2.8,2.8-1.2,2.7-2.8,2.7-2.8-1.2-2.8-2.7ZM265.4,226.6v-23.2h4.3v23.2h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M293.2,226.6v-14.8c0-3.8-2-5.1-4.9-5.1s-5.1,1.6-6.4,3.4v16.6h-4.3v-23.2h4.3v3.3c1.5-1.9,4.6-3.8,8.2-3.8s7.4,2.6,7.4,7.5v16.3h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M319.6,226.6v-2.5c-1.8,2-4.5,3.1-7.6,3.1s-8.1-2.6-8.1-7.7,4.2-7.6,8.1-7.6,5.8,1,7.6,3.1v-3.8c0-2.9-2.4-4.6-5.7-4.6s-4.9,1-7,3.1l-1.9-3c2.6-2.5,5.8-3.8,9.5-3.8s9.3,2.2,9.3,8.1v15.6h-4.3ZM319.6,217.5c-1.3-1.7-3.6-2.6-6-2.6s-5.3,1.9-5.3,4.6,2.2,4.6,5.3,4.6,4.7-.9,6-2.6v-3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M331.8,226.6v-32h4.3v12.2c1.8-2.5,4.6-3.9,7.6-3.9,6,0,10.3,4.8,10.3,12.2s-4.3,12.1-10.3,12.1-5.9-1.6-7.6-3.9v3.3h-4.3ZM336.2,219.9c1.2,1.9,3.8,3.4,6.4,3.4,4.3,0,7-3.5,7-8.3s-2.7-8.4-7-8.4-5.3,1.6-6.4,3.5v9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M359.9,196.8c0-1.5,1.3-2.8,2.8-2.8s2.8,1.2,2.8,2.8-1.2,2.7-2.8,2.7-2.8-1.2-2.8-2.7ZM360.5,226.6v-23.2h4.3v23.2h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M372.7,226.6v-32h4.3v32h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M384.2,196.8c0-1.5,1.3-2.8,2.8-2.8s2.8,1.2,2.8,2.8-1.2,2.7-2.8,2.7-2.8-1.2-2.8-2.7ZM384.8,226.6v-23.2h4.3v23.2h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M397.8,221.4v-14.3h-3.8v-3.8h3.8v-6.3h4.3v6.3h4.7v3.8h-4.7v13.3c0,1.6.8,2.8,2.3,2.8s1.9-.4,2.4-.9l1.1,3.3c-.9.9-2.3,1.5-4.5,1.5-3.6,0-5.5-2.1-5.5-5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M412.1,231.7c.5.2,1.3.4,1.9.4,1.6,0,2.6-.5,3.4-2.3l1.3-3.1-9.6-23.4h4.6l7.2,18.2,7.2-18.2h4.7l-11.4,27.6c-1.5,3.6-4,4.9-7.4,5-.7,0-2-.1-2.7-.3l.7-3.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M461.1,226.6v-13.4h-15.1v13.4h-6.8v-32h6.8v12.6h15.1v-12.6h6.9v32h-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M474.7,194.5h6.9v19c0,4.5,2.4,7.5,7.4,7.5s7.3-3.1,7.3-7.5v-19h6.9v19.2c0,8-4.6,13.4-14.3,13.4s-14.4-5.5-14.4-13.3v-19.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M510.1,226.6v-32h16.8c6.1,0,9.2,3.9,9.2,8.2s-2.5,6.7-5.5,7.3c3.4.5,6.1,3.8,6.1,7.9s-3.2,8.6-9.3,8.6h-17.4ZM516.9,207.4h8.5c2.3,0,3.7-1.5,3.7-3.6s-1.4-3.5-3.7-3.5h-8.5v7.1ZM516.9,220.8h8.8c2.6,0,4.1-1.5,4.1-3.8s-1.4-3.7-4.1-3.7h-8.8v7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M545.4,219.3c2.1,0,3.9,1.8,3.9,3.9s-1.8,3.9-3.9,3.9-3.9-1.8-3.9-3.9,1.8-3.9,3.9-3.9Z"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 227.6,
    y1: 142.6,
    x2: 351.8,
    y2: 142.6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "370.9 103.7 355.4 88.4 355.4 97.7 361.6 103.7 370.9 103.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M379.6,70.8s0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M391.9,103.7l4.7-8.8h23.3l4.8,8.8h8.2l-19.3-35.8c-2.2-4.2-8.4-4.2-10.6,0,0,0-10.5,19.5-16,29.7l-11.5-11.5c3.4-2.1,5.6-5.2,5.6-9.8,0-7.3-5.4-11.6-12.1-11.7h-20c-5.7,0-10.3,4.6-10.3,10.3v23.1c0,3.4,1.8,5.6,5,5.6h1.6v-28.9c0-1.9,1.6-3.6,3.6-3.6h20.6c2.8,0,5.1,2.3,5.1,5.1s-2.3,5.1-5.1,5.1h-7.9l22.2,22.2h8.1ZM400,88.5c1-1.8,7.3-14,8.3-15.8,1,1.8,7.4,14,8.3,15.8h-16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M232,84.2c0,10,7.9,20.2,22.9,20.2s22.9-10.1,22.9-20.2-7.9-20.2-22.9-20.2-22.9,10.1-22.9,20.2M239,84.2c0-6.7,4.2-13.9,16-13.9s16,7.2,16,13.9-4.2,13.9-16,13.9-16-7.2-16-13.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M195.8,64.7c-4.8,0-4.9,6.5,0,6.6h13.2v32.4h7.4v-32.4h13.1c4.8,0,4.8-6.6,0-6.6h-33.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M322.2,67.5s-11.9,19-14.7,23.5c-1.1-1.7-14.7-23.5-14.7-23.5-1.2-1.8-2.2-2.7-5-2.7s-5.1,1.2-5.2,4v35s6.9,0,6.9,0c0,0,0-24,0-28.3,2.3,3.7,14.3,22.9,14.3,22.9,1.8,2.8,5.8,2.8,7.6,0,0,0,10.4-16.7,14.3-22.9,0,4.4,0,28.3,0,28.3h7v-34.9c0-2.5-2.4-4.1-5.2-4.1s-3.9.9-5,2.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "147 91.7 166.5 111.2 180.8 96.9 161.3 77.4 147 77.4 147 91.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M144,60.1c1.9,1.8,3,4.4,3,7.2v10.1h14.3l-17.3-17.3s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M136.8,77.4c-2.8,0-5.3-1.1-7.1-2.9l17.2,17.2v-14.3h-10.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M129.7,74.5c-4-4-4-10.4,0-14.4,3.9-3.9,10.3-4,14.3,0,1.9,1.8,3,4.4,3,7.2v10.1h-10.2c-2.8,0-5.3-1.1-7.1-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M136.9,57.2h0c2.5,0,5.1,1,7.1,2.9,0,0,0,0,0,0h0s17.3,17.3,17.3,17.3h19.5v-20.2h-43.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M126.7,67.3v43.9h20.2v-19.5l-17.2-17.2h0c-2-2-3-4.6-3-7.2h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTomraSustainabilityHubLogo);
export default __webpack_public_path__ + "static/media/TOMRA_SustainabilityHub_Logo.19461abb7c78af53e3ba83d1b437ab2c.svg";
export { ForwardRef as ReactComponent };